import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import AssignmentIcon from '@mui/icons-material/Assignment';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StoreIcon from '@mui/icons-material/Store';
import { GiMoebiusTrefoil } from "react-icons/gi";


import { BiCar } from "react-icons/bi";
import { BiCategory } from "react-icons/bi";
import { BiFolder } from "react-icons/bi";
import { BiUserPin } from "react-icons/bi";

import { NavLink, useLocation, useNavigate } from "react-router";



function NavbarBottom() {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0, pb: "env(safe-area-inset-bottom)", zIndex: 888 }} >
            <Box maxWidth="xxl">
                <BottomNavigation showLabels>
                    <BottomNavigationAction
                        label="Inicio"
                        icon={<BiCategory size={28} color="primary" />}
                        component={NavLink}
                        to="dashboard"
                        className={location.pathname === "/" ? "activo" : ""}


                    />
                    <BottomNavigationAction
                        label="Ordenes"
                        icon={<BiFolder size={28} color="primary" />}
                        component={NavLink}
                        to="ordenes"
                        className={location.pathname === "/" ? "activo" : ""}


                    />
                    <BottomNavigationAction
                        label="Vehiculos"
                        icon={<BiCar size={28} color="primary" />}
                        component={NavLink}
                        to="vehiculos"
                        className={location.pathname === "/" ? "activo" : ""}


                    />
                    <BottomNavigationAction
                        label="Clientes"
                        icon={<BiUserPin size={28} color="primary" />}
                        component={NavLink}
                        to="clientes"
                        className={location.pathname === "/" ? "activo" : ""}


                    />

                </BottomNavigation>
            </Box>
        </Paper>
    );
}

export default NavbarBottom;